export default __webpack_public_path__ + "static/media/digital-store-product-02.11ba4951.jpg";